module.exports = __webpack_public_path__ + "static/media/desktop-picture-large.0fe310ac.jpeg";